export default __webpack_public_path__ + "static/media/svm.e852f913.jpg";